module.exports = __webpack_public_path__ + "static/img/02037D_1_C_20210427_LC.c37212d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/02037D_1_C_20210427_LC.png
// module id = n1kX
// module chunks = 0